// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 177 ? "home" : chunkId) + "." + {"177":"0fb2b868","824":"cd173e0d"}[chunkId] + ".css";
};